import React from 'react';
import { PrimaryCTA, TrustSignals } from './Shared';
export function FinalCTA() {
  return <section className="section" data-id="element-26">
      <h2 className="section-h2 section-h2--center" data-id="element-27">
        El bundle completo, hoy, por $17.
      </h2>

      <p className="final-tagline" data-id="element-28">
        Cuatro recursos. Una sola secuencia. Una decisión de cinco cifras merece
        preparación.
      </p>

      <p className="final-transparency" data-id="element-29">
        Producto digital · Acceso inmediato por email · Garantía 14 días · Ver
        términos completos al pie.
      </p>

      <div className="final-cta-wrap" data-id="element-30">
        <PrimaryCTA ctaId="final" data-id="element-31" />
        <TrustSignals data-id="element-32" />
      </div>
    </section>;
}